//
import Highcharts from 'highcharts';
require('highcharts/modules/debugger')(Highcharts);
require('highcharts/modules/accessibility')(Highcharts);

window.Highcharts = Highcharts;

import { radar_klimadaten } from 'components/frontend/radar_klimadaten';

radar_klimadaten('temperature', 'Durchschnittliche Monatstemperatur', 'in °C');

radar_klimadaten('sun', 'Sonneneinstrahlung', 'in Wh/m²');
radar_klimadaten('sun_accumulated', 'Sonneneinstrahlung kumuliert', 'in Wh/m²');

radar_klimadaten('rain', 'Niederschlag', 'in mm');
radar_klimadaten('rain_accumulated', 'Niederschlag kumuliert', 'in mm');

radar_klimadaten('degree_day', 'Gradtagzahl', '');
radar_klimadaten('degree_day_accumulated', 'Gradtagzahl kumuliert', '');